export class FileToUrlValueConverter {
    toView(file: Blob, baseUrl: any): string {
        return file && typeof file !== "string" ?
            URL.createObjectURL(file) :
            (file ? ((baseUrl != undefined && baseUrl != null ? baseUrl : '') + file.toString()) : "");
    }
}
